// extracted by mini-css-extract-plugin
export var blurb = "alt-footer-module--blurb--aa8c9";
export var copyright = "alt-footer-module--copyright--4b678";
export var footerNavList = "alt-footer-module--footerNavList--dd617";
export var footerNavListItem = "alt-footer-module--footerNavListItem--4a8b7";
export var footerStyle = "alt-footer-module--footerStyle--4ed42";
export var links = "alt-footer-module--links--d913b";
export var logos = "alt-footer-module--logos--585ec";
export var paymentLogo = "alt-footer-module--paymentLogo--b26f7";